// src/features/product-tours/seenToursStorage.ts

import type { ProductTourId, SeenToursMap } from './types';

const STORAGE_PREFIX = 'nauvatek.seenTours.';

function storageKey(uid: string): string {
  return `${STORAGE_PREFIX}${uid}`;
}

export function readLocalSeenTours(uid: string): SeenToursMap {
  try {
    const raw = window.localStorage.getItem(storageKey(uid));
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== 'object') return {};
    return parsed as SeenToursMap;
  } catch {
    return {};
  }
}

export function writeLocalSeenTour(uid: string, tourId: ProductTourId): void {
  try {
    const next = { ...readLocalSeenTours(uid), [tourId]: true };
    window.localStorage.setItem(storageKey(uid), JSON.stringify(next));
  } catch {
    // ignore quota / private mode
  }
}

export function hasSeenTour(
  uid: string,
  tourId: ProductTourId,
  profileSeen?: SeenToursMap | null
): boolean {
  if (profileSeen?.[tourId] === true) return true;
  return readLocalSeenTours(uid)[tourId] === true;
}
